import React from 'react';
import MuiPagination from '@material-ui/lab/Pagination';
export default function Pagination({ meta, onPage }) {
  if (!meta) return null;
  return (
    <div className="portal-admin-pagination hidethis">
      <span>{meta.total} registro(s)</span>
      {meta.last_page > 1 && (
        <MuiPagination
          count={meta.last_page}
          page={meta.current_page}
          onChange={(_, page) => onPage(page)}
          color="primary"
          showFirstButton
          showLastButton
          size="small"
        />
      )}
    </div>
  );
}
